module.exports = __webpack_public_path__ + "media/images/aquagym-3af701a99275c1849b19dea6b2518742.svg";